<template>
  <div class="results detail">
    
    <div class="results-wrap" style="display: block;">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/">{{ $t("nav.home") }}</BreadcrumbItem>
        <BreadcrumbItem to="/onlineMessage">公众留言板 </BreadcrumbItem>
        <BreadcrumbItem>留言详情</BreadcrumbItem>
      </Breadcrumb>
      <div class="results-content boxshadow1" style="padding: 20px 20px;">
      
        <div class="maincontent">
      
          <div v-if="data && data.leaveMsg" >
            <div style="color: rgb(183, 10, 34);
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 10px;">留言详情</div>
            <ul >
              <li>
                <span>留言编号：</span><span>{{data.leaveMsg.no}}</span>
              </li>
              <li>
                <span>留言时间：</span><span>{{data.leaveMsg.msgTime}}</span>
              </li>
              <li>
                <span>留言标题：</span><span>{{data.leaveMsg.title}}</span>
              </li>
           
              <li>
                <span>留言内容：</span><span>{{data.leaveMsg.msg}}</span>
              </li>
            </ul>
          </div>
          <div style="height: 1px;
          clear: both;
          background: #ddd;
          margin-top: 20px;
      "></div>
        <div v-if="data && data.rcvMsg" style="margin-top: 20px;" >
          <div  style="color: rgb(183, 10, 34);
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 10px;">答复信息</div>
          <ul >
           
            <li>
              <span>答复时间：</span><span>{{data.rcvMsg.rcvTime}}</span>
            </li>
           
            <li>
              <span>答复内容：</span><span>{{data.rcvMsg.msg}}</span>
            </li>
          </ul>
        </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Loader from '../layout/Loader'
import Siderbar from './ContentSider'

export default {
  name: 'onlineMessageShow',
  props: ['no'],
  components: { Loader, Siderbar },
  data () {
    return {
      isShowLoader: false,
      data: {}
    }
  },
  watch: {
    no (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.requestData()
      }
    },
    data (newVal, oldVal) {
      if (!this._.isEmpty(newVal)) {
        this._h.setDocTitle(`${this.data.leaveMsg.title} - ${this.$t(this.$route.meta.title)} - ${this.$t('app.name')}`)
      }
    }
    
  },
  created () {
    this.requestData()
  },

  methods: {
    
    requestData () {
     

  
      this.$api.OnlineMessage.getdetail(this.no, {
        success: (response) => {
  
          if (response.data.code === 200) {
            this.data = response.data.data
          }  else {
            this.$Message.warning({content: response.data.message, closable: true})
          }
     
        },
        error: (errorMsg) => {
        
          this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
          this.$Loading.error()
        }
      })
    }
  }
}
</script>
<style scoped>
.maincontent{
  flex: 1;
}
  .results{
    position: relative;
    padding: 15px 0 20px;
  }
  .results-wrap{
    width: 1400px;
    margin: 0 auto;
    position: relative;
    display: flex;
    justify-content: center;
  }
  .shadow-divide{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    box-shadow: 0 2px 4px 0 rgba(223,223,223,0.50);
    z-index: 1;
    height: 5px;
    background-color: #fff;
  }

  .ivu-breadcrumb >>> a:hover{
    color: #1F8AFD;
    text-decoration: none;
    box-shadow: none;
    color:#495060
  }
  .ivu-breadcrumb {
   
    font-size: 16px;
    margin-bottom:20px
}
  .results-content{
    /* width: 80%;
    margin: 0 auto; */
    min-height:calc(100vh - 310px);
    width: 100%;
    position: relative;
    /* padding-left: 290px; */
    display: flex;
    /* justify-content: space-between; */
  }
  .r-sidebar{
    margin-right: 25px;
    /* position: absolute;
    top:0;
    left: 0; */
    width: 260px;
    /* min-height: 100%; */
    background-color: #fff;
  }
  h1{
    /*font-size: 1.4rem;*/
    font-size: 1.6rem;
    font-weight: bold;
    text-align: center;
    padding: 0 15px;
    color: #333;
    margin: 10px 0 8px;
  }
  .results-content .date{
    /*font-size: 1.1rem;*/
    font-size: 1.5rem;
    color: #999;
    text-align: center;
    margin-bottom: 15px;
  }
  .results-content >>> p{
    color: #656565;
    /*font-size: 1.3rem;*/
    font-size: 1.5rem;
    margin-bottom: 10px;
    line-height: 28px;
  }
  li{
    line-height: 36px;
    font-size:16px
  }
  .results-content >>> p:last-child{
    margin-bottom: 0;
  }
  .results-content >>> img{
    display: block;
    max-width: 100%;
    margin: 15px auto;
  }
  .results-content >>> img.cover{
    margin-bottom: 20px;
    margin-top: 0;
    width: 100%;
    max-width: 1000px;
  }

  /*.results-content >>> ul{*/
    /*margin-bottom: 15px;*/
  /*}*/
  .related-links{
    border-top: 0.5px solid #E9E9E9;
    padding-top: 25px;
    margin-bottom: 20px;
    /*font-size: 1.2rem;*/
    font-size: 1.4rem;
    color: #333;
  }
  .related-links .before{
    float: left;
    width: 45%;
    padding-bottom: 2px;
  }
  .related-links .next{
    float: right;
    width: 45%;
    padding-bottom: 2px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/OnlineMessage/Show.vue